import { httpUrl } from "./httpUrl";
import { getData, ifOkToJson, post } from "./index";

let baseUrl = `${httpUrl.host}/gy-electric`;
// let baseUrl = `${httpUrl.localapi}/gy-electric`;
let baseUrl85 = `${httpUrl.host}/gy-apartment`;

let api = {
  // 概览
  getEelectricityStatistics: `${baseUrl}/electricOverview/getEelectricityStatistics`,

  getRechargeStatistics: `${baseUrl}/electricOverview/getRechargeStatistics`,

  getCurrentMonthEelectricity: `${baseUrl}/electricOverview/getCurrentMonthEelectricity`,

  // 设备管理 ———— 查询是否可配置欠费是否关闸
  autoOffSupport: `${baseUrl}/electricMeter/autoOffSupport`,

  // 概览 ———— 充值统计
  getElectricRechargeStatistics: `${baseUrl}/electricOverview/getStatistics`,

  // 获取控制器分页
  getElectricManagerPage: `${baseUrl}/electricManager/getPage`,

  // 获取控制器列表
  getElectricManagerList: `${baseUrl}/electricManager/getList`,

  // 添加控制器
  addElectric: `${baseUrl}/electricManager/add`,

  // 查询单个控制器信息
  getElectricByCode: `${baseUrl}/electricManager/getByCode`,

  // 修改控制器
  updateElectric: `${baseUrl}/electricManager/update`,

  // 删除控制器
  deleteElectric: `${baseUrl}/electricManager/delete`,

  // 获取电表分页
  getElectricMeterPage: `${baseUrl}/electricMeter/getPage`,

  // 获取电表列表
  getElectricMeterList: `${baseUrl}/electricMeter/getList`,

  // 添加电表
  addElectricMeter: `${baseUrl}/electricMeter/add`,

  // 修改电表
  updateElectricMeter: `${baseUrl}/electricMeter/update`,

  // 删除电表
  deleteElectricMeter: `${baseUrl}/electricMeter/delete`,

  // 导入电表
  importElectricMeter: `${baseUrl}/electricMeter/import`,

  // 导出电表
  exportElectricMeter: `${baseUrl}/electricMeter/export`,

  // 生成电表标签
  generateCipherText: `${baseUrl}/codeScanning/generateCipherText`,

  // 导出电表标签
  exportCodeScanning: `${baseUrl}/codeScanning/export`,

  // 导出电表标签
  exportElectricityOnPage: `${baseUrl}/Electricity/export`,

  // 查询单个电表电量
  getElectricityPage: `${baseUrl}/Electricity/getPage`,

  // 查询单个电表信息
  getElectricMeterByCode: `${baseUrl}/electricMeter/getEle`,

  // 获取收款账户
  getAliAccount: `${baseUrl}/electricAliAccount/getAliAccount`,

  // 添加收款账户
  addAliAccount: `${baseUrl}/electricAliAccount/add`,

  // 修改收款账户
  updateAliAccount: `${baseUrl}/electricAliAccount/update`,

  // 获取充值记录
  getElectricConsumptionRecord: `${baseUrl}/electricConsumptionRecord/getPage`,

  // 修改充值记录
  updateElectricConsumptionRecord: `${baseUrl}/electricConsumptionRecord/update`,

  // 批量修改充值记录
  updatePatchElectricConsumptionRecord: `${baseUrl}/electricConsumptionRecord/updatePatch`,

  // 导出充值记录
  exportElectricConsumptionRecord: `${baseUrl}/electricConsumptionRecord/export`,

  // 删除充值账户
  deleteElectricRentMoney: `${baseUrl}/ElectricRentMoney/deleteElectricRentMoney`,

  // 查询推送配置
  getBalanceConfig: `${baseUrl}/balancePushConfig/getBalanceConfig`,

  // 全部推送配置
  updateBalance: `${baseUrl}/balancePushConfig/updateBalance`,

  // 单个推送配置
  pushBalanceConfig: `${baseUrl}/ElectricRentMoney/pushBalanceConfig`,

  // 单个房间账户推送配置
  pushRoomBalanceConfig: `${baseUrl}/electricRoomMoney/pushBalanceConfig`,

  // 获取住户列表
  getEnterpriseList: `${baseUrl85}/enterpriseInfo/getEnterpriseList`,

  // 获取余额
  getElectricRentMoneyPage: `${baseUrl}/electricRoomMoney/getPage`,

  // 获取余额明细
  getAccountDetailsPage: `${baseUrl}/electricRoomAccountDetails/getPage`,

  // 导出余额
  exportElectricRentMoney: `${baseUrl}/ElectricRentMoney/export`,

  // 导出房间余额
  exportElectricRoomMoney: `${baseUrl}/electricRoomMoney/export`,

  // 充值
  recharge: `${baseUrl}/ElectricRentMoney/recharge`,

  // 结算
  settlement: `${baseUrl}/ElectricRentMoney/settlement`,

  // 结算记录
  getSettlementPage: `${baseUrl}/electricSettlement/getPage`,

  // 导出结算记录
  exportSettlement: `${baseUrl}/electricSettlement/export`,

  // 获取园区责任人
  getResponsiblePersonList: `${baseUrl85}/person/getResponsiblePersonList`,

  // 获取支付宝账户列表
  getAccountList: `${baseUrl}/feign/aliAccount/getAccountList`,

  // 获取金额配置参数
  getElectricPayConfigList: `${baseUrl}/electricPayConfig/getList`,

  // 获取金额配置参数
  updateElectricPayConfig: `${baseUrl}/electricPayConfig/update`,

  // 账单
  getElectricBillPage: `${baseUrl}/electricBillMeter/getPage`,

  // 导出账单
  exportElectricBill: `${baseUrl}/electricBillMeter/export`,

  // 企业用电统计
  getElectricBillEnterprisePage: `${baseUrl}/electricBillEnterprise/getPage`,

  // 导出公摊电费模板
  exportElectricBillEnterprise: `${baseUrl}/electricBillEnterprise/export`,

  // 导出房间公摊电费模板
  exportElectricBillRoom: `https://damai-gy.oss-cn-hangzhou.aliyuncs.com/template/gy_public_electric_template.xlsx`,

  // 导出企业用电统计
  exportBillEnterprise: `${baseUrl}/electricBillEnterprise/exportBillEnterprise`,

  // 导入公摊用电账单
  importElectricBillEnterprise: `${baseUrl}/electricBillEnterprise/import`,

  // 导出房间用电统计
  exportBillRoom: `${baseUrl}/electricBillRoom/exportBillEnterprise`,

  // 导入房间公摊用电账单
  importElectricBillRoom: `${baseUrl}/electricBillRoom/import`,

  // 企业用电统计
  getRoomBillPage: `${baseUrl}/electricBillRoom/getPage`,

  // 获取设备厂家
  getAllDeviceManufacture: `${baseUrl85}/common/getAllDeviceManufacture`,

  // 获取设备型号
  getAllDeviceType: `${baseUrl85}/common/getAllDeviceType`,

  // 获取楼栋列表
  getBuildingList: `${baseUrl85}/building/getBuildingList`,

  // 场景
  getElectricScenePage: `${baseUrl}/electricScene/getPage`,

  // 场景列表
  getElectricSceneList: `${baseUrl}/electricScene/getList`,

  // 父级电表
  getElectricMeterParentList: `${baseUrl}/electricMeter/getParentList`,

  // 添加场景
  addElectricSceneByCodes: `${baseUrl}/electricScene/add`,

  // 删除
  deleteElectricSceneByCodes: `${baseUrl}/electricScene/deleteByCodes`,

  // 电控数据概览
  // 集中器
  getElectricControlDeviceOverview: `${baseUrl}/electricOverview/getElectricControlDeviceOverview`,

  // 电表
  getElectricMeterDeviceOverview: `${baseUrl}/electricOverview/getElectricMeterDeviceOverview`,

  // 用电量
  getEelectricity: `${baseUrl}/electricOverview/getEelectricity`,

  // 住户
  getEnterprisePageByCondition: `${baseUrl}/electricOverview/getEnterprisePageByCondition`,

  // 集中器设备状态
  getElectricControlDeviceStatusPage: `${baseUrl}/electricControlDeviceStatus/getPage`,

  // 导出集中器设备状态
  exportElectricControlDeviceStatus: `${baseUrl}/electricControlDeviceStatus/export`,

  //获取电费结算配置
  getElectricSettlementConfig: `${baseUrl}/electricSettlementConfig/get`,

  //电费结算配置保存
  saveElectricSettlementConfig: `${baseUrl}/electricSettlementConfig/save`,

  // 电表最新读数分页
  getElectricRealRecordPage: `${baseUrl}/electricRealRecord/getPage`,

  // 导出电表最新读数
  exportElectricRealRecord: `${baseUrl}/electricRealRecord/export`
};

export { api };



// WEBPACK FOOTER //
// ./src/view/api/ElectronicManagement.js